import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { CountriesService } from 'src/app/countries/countries.service';
import { ProvincesService } from '../provinces.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';

@Component({
  selector: 'app-provinces-list',
  templateUrl: './provinces-list.component.html',
  styleUrls: ['./provinces-list.component.scss']
})
export class ProvincesListComponent implements OnInit {

  @ViewChild("grid") public grid: Table;
  public provincesFilters: any = {};
  public provinces: any[];
  public countries: any[];
  public totalRecords: number;
  public loading: boolean = false;
  private lastGridEvent: any;

  constructor(private provincesService: ProvincesService,
    private countriesService: CountriesService,
    private router: Router,
    private coreDialogService: CoreDialogService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.loadCountries();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  clearFilters() {
    this.provincesFilters = {};
    this.search();
  }

  loadData($event) {
    this.lastGridEvent = $event;
    Promise.resolve(null).then(() => this.loading = true);
    var params = {
      _page: $event.first,
      _pageSize: $event.rows,
      _sortBy: $event.sortField ? $event.sortField : "",
      _sortDirection: $event.sortOrder > 0 ? "asc" : "desc"
    };
    params = Object.assign(params, this.provincesFilters);
    this.provincesService.all(params).subscribe(
      data => {
        this.totalRecords = data.totalRows;
        this.provinces = data.rows;
        Promise.resolve(null).then(() => this.loading = false);
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        Promise.resolve(null).then(() => this.loading = false);
      }
    );
  }

  loadCountries(){
    this.countriesService.all({}).subscribe(
      data=>{
        this.countries = data.rows;
      },
      error=>{
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  edit(province) {
    this.router.navigate(['/configuration/provinces/', province.id]);
  }

  delete(province) {
    this.coreDialogService.confirm({
      message: '¿Quieres borrar la provincia ' + province.name + '?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.provincesService.delete(province.id).subscribe(
          data => {
            this.loadData(this.lastGridEvent);
          },
          error => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        );
      },
      reject: () => {

      }
    });
  }

}
